module.exports = __webpack_public_path__ + "static/media/sin_historial.ee1d206a.svg";